module.exports = __webpack_public_path__ + "img/cloth_g3_hat-13.cfa881d6.svg";